import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Typography } from '@material-ui/core'
import moment from 'moment'
import { ROUTES } from 'routes'

import { useStyles } from './ChampionshipCard.style'

const ChampionshipCard = ({ championship }) => {
  const classes = useStyles()

  const { from, to, slugUrl, name } = championship
  const fromLocal = moment(from)
  const toLocal = moment(to)

  const championshipDateFormat = fromLocal.isSame(toLocal, 'years')
    ? fromLocal.format('YYYY')
    : `${fromLocal.format('YYYY')}/${toLocal.format('YYYY')}`

  return (
    <Link className={classes.card} to={`${ROUTES.CHAMPIONSHIPS.PROFILE}/${slugUrl}`}>
      <div className={classes.mainContainer}>
        <div className={classes.dateContainer}>
          <Typography className={classes.date} variant='h6' textAlign='center'>
            {championshipDateFormat}
          </Typography>
        </div>

        <div className={classes.content}>
          <Typography color='primary' variant='h5' className={classes.title} title={name}>
            {name}
          </Typography>

          <Button variant='outlined' color='primary' className={classes.button}>
            Ver Campeonato
          </Button>
        </div>
      </div>
    </Link>
  )
}

export default ChampionshipCard
